class WelcomeDiscountPopup extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'stynnco:welcome-discount-popup-dismissed-at';
    this.discountCode = this.dataset.discountCode || 'STYNNCO10';
    this.hideDays = Number(this.dataset.hideDays || 7);
    this.copyButton = this.querySelector('[data-discount-popup-copy]');
    this.closeButtons = this.querySelectorAll('[data-discount-popup-close]');
    this.panel = this.querySelector('.welcome-discount-popup__panel');
    this.openTimer = null;
    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (this.shouldStayHidden()) return;

    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close(true)));
    this.copyButton?.addEventListener('click', () => this.copyCode());
    this.openTimer = window.setTimeout(() => this.open(), 1400);
  }

  disconnectedCallback() {
    if (this.openTimer) window.clearTimeout(this.openTimer);
    document.removeEventListener('keydown', this.onKeydown);
  }

  shouldStayHidden() {
    try {
      const dismissedAt = Number(window.localStorage.getItem(this.storageKey));
      if (!dismissedAt) return false;

      const hideMs = this.hideDays * 24 * 60 * 60 * 1000;
      return Date.now() - dismissedAt < hideMs;
    } catch (error) {
      return false;
    }
  }

  rememberDismissal() {
    try {
      window.localStorage.setItem(this.storageKey, String(Date.now()));
    } catch (error) {
      // Storage can be unavailable in private browsing; the popup still works.
    }
  }

  open() {
    this.hidden = false;
    document.body.classList.add('welcome-discount-popup-open');
    window.requestAnimationFrame(() => {
      this.classList.add('is-visible');
      this.panel?.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', this.onKeydown);
  }

  close(remember = false) {
    if (remember) this.rememberDismissal();

    this.classList.remove('is-visible');
    document.body.classList.remove('welcome-discount-popup-open');
    document.removeEventListener('keydown', this.onKeydown);

    window.setTimeout(() => {
      this.hidden = true;
    }, 220);
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close(true);
  }

  async copyCode() {
    if (!this.copyButton) return;

    try {
      await navigator.clipboard.writeText(this.discountCode);
      this.copyButton.textContent = 'Copied';
      window.setTimeout(() => {
        this.copyButton.textContent = 'Copy code';
      }, 1800);
    } catch (error) {
      this.copyButton.textContent = this.discountCode;
    }
  }
}

if (!customElements.get('welcome-discount-popup')) {
  customElements.define('welcome-discount-popup', WelcomeDiscountPopup);
}
